module.exports = __webpack_public_path__ + "static/img/J.8408e3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ssxxg/J.png
// module id = AlgS
// module chunks = 0